const styles = {
  card: {
    my: 2,
    gap: 2,
  },
  datagrid: {
    flex: 1,
    minHeight: 0,
    '& .MuiDataGrid-main': {
      minHeight: 0,
    },
  },
  button: {
    alignSelf: 'center',
  },
};

export default styles;
